export default __webpack_public_path__ + "static/media/sign-up-background.00261603.jpg";